module.exports = __webpack_public_path__ + "static/media/LOGO PANJANG SDI.d98a8f17.png";